// extracted by mini-css-extract-plugin
export default {"photoContainer":"add-edit-pet-modal_photoContainer__JP6ek","petImage":"add-edit-pet-modal_petImage__lpGqe","petAddImage":"add-edit-pet-modal_petAddImage__tQzNs"};